/* @ngInject */
const readinessOptions = (
  utils,
  types,
  excelStyles,
  wagonUtils,
) => {
  const self = {}

  self.generateOptions = (_options) => {
    const options = utils.copy(_options)
    options.filename = 'readinessCertificate'
    options.enableColor = true
    options.enableOwnerSheet = false
    options.firstRow = 6
    options.getBodyCells = self.getBodyCells
    options.style = excelStyles.bodyCell()

    return options
  }

  self.getBodyCells = ({ currentRow, }, wagon) => {
    return [{
      name: 'A' + currentRow,
      ref: 'id',
      value: wagon.id,
      type: types.wagonId,
    }, {
      name: 'B' + currentRow,
      ref: 'type',
      value: wagon.type,
    }, {
      name: 'C' + currentRow,
      ref: 'railway',
      value: wagon.railway,
    }, {
      name: 'D' + currentRow,
      ref: 'length',
      value: wagon.length,
      type: types.decimal,
    }, {
      name: 'E' + currentRow,
      ref: 'owner',
      value: wagon.owner,
    }, {
      name: 'F' + currentRow,
    }, {
      name: 'G' + currentRow,
      value: 180,
      type: types.euro,
    }, {
      name: 'H' + currentRow,
      value: wagon.idNew ? `Nouveau numéro : \n${wagonUtils.idToString(wagon.idNew)}` : ''
    },]
  }

  return self
}
export default readinessOptions



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/wagon/readinessOptions.resource.js